"use strict";
// SPDX-FileCopyrightText: 2024 Red Bee Media Ltd <https://www.redbeemedia.com/>
//
// SPDX-License-Identifier: MIT
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaSessionManager = void 0;
const js_player_shared_1 = require("@ericssonbroadcastservices/js-player-shared");
const AbstractPlayer_1 = require("../players/AbstractPlayer");
const ActionHandlers = {
    PLAY: "play",
    PAUSE: "pause",
    PREVIOUS_TRACK: "previoustrack",
    NEXT_TRACK: "nexttrack",
    SEEK_BACKWARD: "seekbackward",
    SEEK_FORWARD: "seekforward",
    SEEKTO: "seekto",
    STOP: "stop",
};
class MediaSessionManager {
    constructor(playerInstance, instanceSettings) {
        this.playerInstance = playerInstance;
        this.asset = instanceSettings.assetMetadata;
        this.customer = document.title || instanceSettings.initOptions.customer;
        this.locale = instanceSettings.initOptions.locale || "en";
        this.setup();
    }
    setup() {
        if ("mediaSession" in navigator) {
            this.setMetadata();
            this.setupEventListeners();
            this.setupStateReporter();
        }
    }
    setMetadata() {
        if (!this.asset) {
            return;
        }
        const title = (0, js_player_shared_1.getAssetTitle)(this.asset, this.locale);
        const images = (0, js_player_shared_1.getAssetImages)(this.asset, this.locale).map((image) => ({
            src: image.url,
            sizes: `${image.width}x${image.height}`,
        }));
        if (!title)
            return;
        navigator.mediaSession.metadata = new MediaMetadata({
            title,
            artist: this.customer,
            artwork: images,
        });
    }
    setupEventListeners() {
        // Wrap all setActionHandler in try/catch, see: https://github.com/w3c/mediasession/issues/228?ts=2
        try {
            navigator.mediaSession.setActionHandler(ActionHandlers.PLAY, () => __awaiter(this, void 0, void 0, function* () {
                yield this.playerInstance.play();
                navigator.mediaSession.playbackState = "playing";
            }));
        }
        catch (e) {
            // no-op
        }
        try {
            navigator.mediaSession.setActionHandler(ActionHandlers.PAUSE, () => {
                this.playerInstance.pause();
                navigator.mediaSession.playbackState = "paused";
            });
        }
        catch (e) {
            // no-op
        }
        try {
            navigator.mediaSession.setActionHandler(ActionHandlers.SEEK_BACKWARD, () => {
                this.playerInstance.scrub(-15);
            });
        }
        catch (e) {
            // no-op
        }
        try {
            navigator.mediaSession.setActionHandler(ActionHandlers.SEEK_FORWARD, () => {
                this.playerInstance.scrub(15);
            });
        }
        catch (e) {
            // no-op
        }
        try {
            navigator.mediaSession.setActionHandler(ActionHandlers.SEEKTO, ({ seekTime }) => {
                if (seekTime !== null) {
                    this.playerInstance.seekTo(seekTime);
                }
            });
        }
        catch (e) {
            // no-op
        }
    }
    setupStateReporter() {
        var _a;
        if ((_a = navigator.mediaSession) === null || _a === void 0 ? void 0 : _a.setPositionState) {
            this.playerInstance.on(AbstractPlayer_1.INTERNAL_STATE_CHANGED, (state) => {
                if (!this.playerInstance.isLive() &&
                    state.duration > 0 &&
                    state.currentTime &&
                    state.currentTime <= state.duration) {
                    navigator.mediaSession.setPositionState({
                        duration: state.duration,
                        position: state.currentTime,
                    });
                }
            });
        }
    }
}
exports.MediaSessionManager = MediaSessionManager;
//# sourceMappingURL=MediaSessionManager.js.map